<template>
  <div class="app-header">
    <div class="headed_left">
      <img src="@/assets/yunlogo.png" alt="" />
      <h3>医疗机构在线考核云平台</h3>
    </div>
    <!-- 头部右侧 -->
    <div class="headed_right">
      <div class="content" v-if="type != 'ks'">
        <h5>
          医院归属码：<span style="color: #1890ff">{{
            userObj.HospitalCode
          }}</span>
        </h5>
      </div>
      <!-- <div class="backkhy" @click="backold" :class="type == 'ks' ? 'mr12' : ''">
        <img src="../../../assets/checkout.png" alt="" />
        <h5>切换老版本</h5>
      </div> -->
      <div class="content" @click="dialogVisible = true" v-if="type != 'ks'">
        <img src="../../../assets/checkout.png" alt="" />
        <h5>{{ select.softName }}</h5>
      </div>
      <el-dropdown class="dropdown_box" :class="type == 'ks' ? 'mr12' : ''">
        <span class="el-dropdown-link2">
          <img src="../../../assets/checkout.png" alt="" />
          <h5>帮助</h5>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <div class="dropdwon-items" @click="toHelp">
              <div class="icon-dropOptions">
                <i class="el-icon-notebook-2"></i>
              </div>
              <div class="dropText">
                <p>帮助文档</p>
                <span>去看看</span>
              </div>
            </div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div class="dropdwon-items">
              <div class="icon-dropOptions">
                <i class="el-icon-phone-outline"></i>
              </div>
              <div class="dropText">
                <p>售后服务</p>
                <span>QQ：1926197022</span>
              </div>
            </div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div class="dropdwon-items" @click="toQusetion">
              <div class="icon-dropOptions">
                <i class="el-icon-user"></i>
              </div>
              <div class="dropText">
                <p>问题反馈</p>
                <span>提交反馈</span>
              </div>
            </div>
          </el-dropdown-item>
          <!--<el-dropdown-item-->
          <!--&gt;<div class="dropdwon-items">-->
          <!--<div class="icon-dropOptions">-->
          <!--<i class="el-icon-download"></i>-->
          <!--</div>-->
          <!--<div class="dropText">-->
          <!--<p>下载医考拉</p>-->
          <!--<span>提交反馈</span>-->
          <!--</div>-->
          <!--</div></el-dropdown-item>-->
        </el-dropdown-menu>
      </el-dropdown>

      <!-- 右侧用户信息展示 -->
      <el-dropdown class="dropdown_box_right">
        <span class="el-dropdown-link">
          <!-- 用户头像。使用 Avatar 组件 -->
          <el-avatar :size="30" :src="content" default>
            <img :src="content" alt="" />
          </el-avatar>
          <h3>
            {{ type == "ks" ? ksName : userObj.HospitalName }}
            <span class="red_span" v-if="endtimeType != 3">提示!</span>
          </h3>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu
          class="userInfo"
          slot="dropdown"
          :class="colorType(endtime)"
        >
          <el-dropdown-item v-if="type != 'ks'">
            <!-- <p>有效期至:</p>
            <div class="prompt_view">
              <p :class="colorType(endtime)">
                {{ $moment(endtime).format("YYYY-MM-DD") }}
              </p>
              <el-button @click="details" v-if="endtimeType != 3"
                >提示</el-button
              >
            </div> -->
          </el-dropdown-item>
          <el-dropdown-item @click.native="toNotice">公告</el-dropdown-item>
          <el-dropdown-item @click.native="userName">用户名</el-dropdown-item>
          <el-dropdown-item @click.native="batchDelete = true"
            >退出</el-dropdown-item
          >
        </el-dropdown-menu>
        <div class="bubbles_box" v-if="isan == true">
          <div class="triangle"></div>
          <p>您有{{ newMsg }}条新消息，<span @click="toMessage">查看</span></p>
        </div>
      </el-dropdown>

      <div class="dialog_view">
        <el-dialog
          :visible.sync="dialogVisible"
          custom-class="dialogcontent"
          :show-close="false"
          :close-on-click-modal="false"
        >
          <div slot="title" class="dialog-title">
            <!-- <i class="el-icon-edit-outline"></i> -->
            <img src="../../../assets/dialogtitle.png" alt="" />
            <h4>考核云平台题库</h4>
            <div class="dialogclose">
              <img
                src="../../../assets/dialogimg/dialogclose.png"
                alt=""
                @click="cancel"
              />
            </div>
          </div>
          <div class="dialog-body">
            <div class="dialog-body-first">
              <div
                class="cardcontent"
                @click="selecttest(dateimg[0].softName, dateimg[0].ID)"
              >
                <h3>{{ this.dateimg[0].softName }}</h3>
                <img src="../../../assets/dialogimg/content1.png" alt="" />
              </div>
              <div
                class="cardcontent"
                @click="selecttest(dateimg[1].softName, dateimg[1].ID)"
              >
                <h3>{{ dateimg[1].softName }}</h3>
                <img src="../../../assets/dialogimg/content2.png" alt="" />
              </div>
              <div
                class="cardcontent"
                @click="selecttest(dateimg[2].softName, dateimg[2].ID)"
              >
                <h3>{{ dateimg[2].softName }}</h3>
                <img src="../../../assets/dialogimg/content3.png" alt="" />
              </div>
            </div>
            <div class="dialog-body-first">
              <div
                class="cardcontent"
                @click="selecttest(dateimg[3].softName, dateimg[3].ID)"
              >
                <h3>{{ dateimg[3].softName }}</h3>
                <img src="../../../assets/dialogimg/content4.png" alt="" />
              </div>
              <div
                class="cardcontent"
                @click="selecttest(dateimg[4].softName, dateimg[4].ID)"
              >
                <h3>{{ this.dateimg[4].softName }}</h3>
                <img src="../../../assets/dialogimg/content5.png" alt="" />
              </div>
              <div
                class="cardcontent"
                @click="selecttest(dateimg[5].softName, dateimg[5].ID)"
              >
                <h3>{{ dateimg[5].softName }}</h3>
                <img src="../../../assets/dialogimg/content6.png" alt="" />
              </div>
            </div>
            <div class="dialog-body-first">
              <div
                class="cardcontent"
                @click="selecttest(dateimg[6].softName, dateimg[6].ID)"
              >
                <h3>{{ dateimg[6].softName }}</h3>
                <img src="../../../assets/dialogimg/content7.png" alt="" />
              </div>
              <div
                class="cardcontent"
                @click="selecttest(dateimg[7].softName, dateimg[7].ID)"
              >
                <h3>{{ this.dateimg[7].softName }}</h3>
                <img src="../../../assets/dialogimg/content8.png" alt="" />
              </div>
              <div
                class="cardcontent"
                @click="selecttest(dateimg[8].softName, dateimg[8].ID)"
              >
                <h3>{{ dateimg[8].softName }}</h3>
                <img src="../../../assets/dialogimg/content9.png" alt="" />
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
      <div class="deleteExit">
        <el-dialog
          title="温馨提示"
          :visible.sync="batchDelete"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <p>此操作将退出登陆，是否继续？</p>
          <span slot="footer" class="dialog-footer">
            <el-button @click="batchDelete = false">取 消</el-button>
            <el-button type="primary" @click="handleLogout">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <!-- 开屏弹窗 -->
      <!-- <div
        class="Popup_view"
        :class="{ isPopup: isShowReport }"
        @click="toTail"
      >
        <el-dialog :visible.sync="PopupDatalist" :close-on-click-modal="false">
          <img
            src="../../../assets/dialogimg/Popup.png"
            alt=""
            class="img_down"
            @click="PopupDatalist = false"
          />
          <el-button
            class="receivw"
            v-if="!isShowReport"
            @click="openReport"
          ></el-button>
          <iframe
            :src="iframedata"
            class="iframe"
            v-if="isShowReport"
            ref="iframe"
            frameborder="0"
          ></iframe>
        </el-dialog>
      </div> -->
      <!-- <firstcom></firstcom> -->
      <PromptPopup :obj="infoObj" ref="PromptPopup" />
      <div class="upDateback">
        <el-dialog
          :visible.sync="upDateBan"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <div class="zidingyiheader">
            <p>更新版本</p>
            <i class="closebtn" @click="upDateBan = false"></i>
          </div>
          <h2 v-html="updateMsg"></h2>
          <span slot="footer" class="dialog-footer dibu">
            <el-button @click="noRenew">不在提醒</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import firstcom from "./FirstComponent.vue";
import systemclass from "@/api/systemclassification";
import systemclassification from "@/api/systemclassification";
import qusetionfcuntion from "@/api/questionbank";
import { getUserInfo, newMsgCount } from "@/api/examination.js";
import loginvuex from "../../../store/index";
import { mapState } from "vuex";
import { isInitHospital, initRoleData } from "@/api/permissions";
import ossClient from "@/utils/aliyunOssClient";
import {resetRouter} from '../../../router/index'
import PromptPopup from "../../../components/promptPopup";
export default {
  data() {
    return {
      renewId: "",
      updateMsg: "",
      upDateBan: false, //更新版本
      stateArr: [], //存储开始时间和结束时间。
      iframedata: "http://121.40.220.32:8030", //传递给子页面的信息
      img: "@/assets/notice.png",
      isfirstlogin: "", //首次登录
      // newMsg: "", // 有几条消息通知
      isShowReport: false, //弹窗报告。
      newMsgShow: loginvuex.state.isan, // 消息栏是否显示气泡
      dialogVisible: false,
      nowtimes: "", //当前时间
      onlinetime: "2021/12/24 23:59", //上线时间
      select: {
        ID: "",
        softName: ""
      },
      PopupDatalist: false,
      batchDelete: false,
      dateimg: [
        { ID: "1", softName: "医学考试(全题库)" },
        { ID: "2", softName: "医学三基考试系统" },
        { ID: "3", softName: "中医考试系统" },
        { ID: "4", softName: "护理考试系统" },
        { ID: "5", softName: "临床医学考试系统" },
        { ID: "6", softName: "住院医师考试系统" },
        { ID: "7", softName: "卫生系统招聘考试系统" },
        { ID: "8", softName: "医学法律法规考试系统" },
        { ID: "9", softName: "其他培训考试系统" }
      ],
      portraitArr: [
        {
          photoID: 1,
          imgUrl: require("@/assets/portrait/1.png")
        },
        {
          photoID: 2,
          imgUrl: require("@/assets/portrait/2.png")
        },
        {
          photoID: 3,
          imgUrl: require("@/assets/portrait/3.png")
        },
        {
          photoID: 4,
          imgUrl: require("@/assets/portrait/4.png")
        },
        {
          photoID: 5,
          imgUrl: require("@/assets/portrait/5.png")
        },
        {
          photoID: 6,
          imgUrl: require("@/assets/portrait/6.png")
        },
        {
          photoID: 7,
          imgUrl: require("@/assets/portrait/7.png")
        },
        {
          photoID: 8,
          imgUrl: require("@/assets/portrait/8.png")
        },
        {
          photoID: 9,
          imgUrl: require("@/assets/portrait/9.png")
        }
      ],
      date: {
        userID: "",
        guid: "",
        hid: ""
      },
      // 默认头像这里采用oss图片，会有文件找不到报错,后续处理
      content:
        "http://yingedu-video4.oss-cn-shenzhen.aliyuncs.com/newkhy/pro/190/trina_77/activity_16697085704330.png?OSSAccessKeyId=LTAI5tPu8jJMiMybUXUSpMvp&Expires=2615788574&Signature=o3l4xA67yIXcEYpfPOnP6GdumCY%3D", //头像
      userObj: {},
      infoObj: {},
      userinfo: {},
      endtime: "",
      endtimeType: "", // 是否不足二个月或则一周
      type: "", // 是否是考生登录
      ksName: ""
    };
  },
  props: ["reload", "types"],
  methods: {
    toNotice() {
      //  this.$root.$Navbottom("消息通知", "Alerts"); // 这位置是文浩写的，不知道干嘛，会报错
      // this.$router.push("/Alerts");
      this.$router.push("/user_center/alerts");
    },
    //跳转帮助文档
    toHelp() {
      window.open(
        "https://yingedu-video4.oss-cn-shenzhen.aliyuncs.com/yypt/product/courseware/999999/59/%E8%80%83%E6%A0%B8%E4%BA%912.0%E7%89%88PC%E7%AB%AF%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf"
      );
      // let fileUrl = "yypt/product/courseware/999999/59/考核云2.0版PC端操作手册.pdf";
      // let url = await ossClient.getFileUrl(fileUrl);
    },
    toQusetion() {
      //问题反馈
      this.$root.$Navbottom("用户反馈", "Feedback");
      // this.$router.push("/feedback");
      this.$router.push("/user_center/feedback");
    },
    cancel() {
      if (this.isfirstlogin) {
        this.$message.error("首次登录请选择一个题库");
      } else {
        this.dialogVisible = false;
      }
    },
    backold() {
      this.$confirm("将返回老版考核云", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false
      })
        .then(() => {
          let link = document.createElement("a");
          link.style.display = "none";
          let url = `http://khy.tibosi.com/login.html?newusername=${
            JSON.parse(localStorage.getItem("userlist")).userName
          };password=${localStorage.getItem("pws")}`;
          link.href = url;
          link.setAttribute("target", "_self");
          document.body.appendChild(link);
          link.click();
          //释放URL对象所占资源
          window.URL.revokeObjectURL(url);
          //用完即删
          document.body.removeChild(link);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 开屏跳转
    toTail() {
      this.Buriedpoint(
        {
          code: "AnnualReview",
          parent_code: null
        },
        null,
        null
      );
      // console.log("跳转了");
    },
    // 查看跳转消息通知
    toMessage() {
      this.$router.push("/user_center/alerts");
      // this.$router.push("/Alerts");
    },
    //去到年度报告
    openReport() {
      this.isShowReport = true;
    },
    // 判断是否有消息通知
    async messageShow() {
      let parmes = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid
      };
      const { data } = await newMsgCount(parmes);
      if (data.Status == 200) {
        loginvuex.state.newMsg = data.Data.newMsg; // 条数
        if (this.newMsg != 0) {
          loginvuex.state.isan = true; // vuex定义的值判断气泡是否显示
        }
      }
    },
    async selecttest(a, b) {
      this.Buriedpoint(
        { code: "homepageSubject:list", parent_code: "homepageSubject" },
        "statetime",
        "appsortID",
        b
      );
      this.reload();
      this.select.softName = a;
      this.select.ID = b;
      this.dialogVisible = false;
      this.$message({
        message: `切换到${a}`,
        type: "success"
      });
      let date = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
        ID: Number(b),
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid
      };
      systemclassification.setsystem(date); //设置系统分类的类型
      let resr = await qusetionfcuntion.examApp(date);
      localStorage.setItem("testbank", JSON.stringify(resr.data.Data));
      // console.log("设置数据成功");
    },
    userName() {
      this.$router.push("/user_center/basis");
    },
    // 埋点
    Buriedpoint(itemt, isstate, type, id) {
      let parmas = {
        type: "2",
        code: itemt.code,
        parent_code: itemt.parent_code,
        stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        stay_time: 1,
        ation_source: null,
        source: "khy",
        ip: null,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid
      };
      if (isstate == "statetime" && null) {
        //次数
        systemclass.addburied(parmas);
      } else if (isstate == "statetime" && type == "appsortID") {
        // 因九个系统需多传一个参
        parmas.appsortID = id;
        systemclass.addburied(parmas);
      } else if (isstate == null) {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parma = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid
          };
          systemclass.addburied(parma);
          this.stateArr = [];
        }
      }
    },
    // 详情
    details() {
      this.$refs.PromptPopup.dialogVisibleObj.prompt = true;
      this.userinfo = JSON.parse(sessionStorage.getItem("xufeiInfo"));
      let user = JSON.parse(localStorage.getItem("userlist"));
      this.infoObj = {
        title: `尊敬的${this.userinfo.hospitalName}`,
        agent: this.userinfo.agent,
        endtime: this.$moment(this.userinfo.endtime).format("YYYY-MM-DD"),
        price: this.userinfo.price,
        // price: 6666,
        type: "",
        hospitalName: this.userinfo.hospitalName,
        realName: user.realName,
        endtimeType: this.endtimeType // 1不足一周，2不足二个月
      };
      // this.userinfo.agent = "直销";
      // console.log(this.userinfo.agent,'===============>>>',this.userinfo.price);
      let type = this.userinfo.agent.indexOf("直销") != -1;
      if (type == true && this.userinfo.price !== null) {
        this.infoObj.type = "直销"; // 直销显示续费按钮
      } else {
        this.infoObj.type = "代理商";
      }
      console.log(type, this.infoObj.type);
    },
    // 退出功能
    handleLogout() {
      // console.log(1);
      // 1. 清除 store 中的用户的信息
      this.$store.commit("setUser", null);
      localStorage.removeItem("userlist");
      window.name = ""; // 清除初始系统弹窗提示状态
      resetRouter()
      // 2. 跳转登录页
      this.$router.push("/login");
      this.$message({
        type: "success",
        message: "退出成功!"
      });
    },
    // 头像
    fn() {
      // 页面进来的头像渲染判断
      let imgID = this.userObj.photoID;
      this.portraitArr.map(item => {
        if (imgID == item.photoID) {
          this.content = require(`@/assets/portrait/${imgID}.png`);
        }
      });
    },
    async getUserData() {
      let parmas = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid
      };
      const res = await getUserInfo(parmas);
      // console.log(res.data.Data[0], "获取到头像了");
      if (res.data.Status === 200) {
        this.userObj = res.data.Data[0];
        this.fn();
      }
      // console.log(this.userObj, "========================》》》");
    },
    timeFrom(time) {
      //计算当前时间。
      this.nowtimes = this.$moment(time).format("YYYY/MM/DD HH:mm:ss");
    },
    nowtime() {
      //重复计算
      this.timeFrom(new Date());
      setTimeout(() => {
        this.nowtime();
      }, 1000);
      this.creal();
    },
    creal() {
      clearTimeout(this.nowTimes); //清楚当前时间
      this.nowTimes = null;
    },
    InitHospital() {
      let pamars = {
        HospitalID: JSON.parse(loginvuex.state.userlist).hid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid
      };
      isInitHospital(pamars).then(res => {
        if (res.data.Data == 0) {
          initRoleData(pamars);
        }
      });
    },
    getUpdate() {
      let parms = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid
      };
      systemclass.getRenewKhy(parms).then(res => {
        // console.log("Renew=======",res);
        if (res.data.Data.length > 0) {
          this.upDateBan = true;
          this.updateMsg = res.data.Data[0].content;
          this.renewId = res.data.Data[0].id;
        }
      });
    },
    noRenew: function() {
      let parms = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid
      };
      parms.renewId = this.renewId;
      systemclass.noRenewKhy(parms);
      this.upDateBan = false;
    }
  },
  components: {
    PromptPopup
  },
  computed: {
    ...mapState(["isan", "newMsg"]),
    loginvuexs() {
      return loginvuex;
    },
    stillTime() {
      const mm = this.$moment(new Date(this.onlinetime)).diff(
        new Date(this.nowtimes),
        "minutes"
      );
      const ss = this.$moment(new Date(this.onlinetime)).diff(
        new Date(this.nowtimes),
        "seconds"
      ); //秒数
      const hh = Math.floor(mm / 60); //相差的小时数
      const h = hh % 24; //相差的小时差余
      const d = Math.floor(mm / 60 / 24); //相差的天数
      const mmm = mm % 60; //计算相差小时后余下的分钟数
      const s = ss % 60; //计算时间余数。
      return d + "天" + h + "小时" + mmm + "分钟" + s + "秒";
    },
    colorType() {
      return function(time) {
        // time = "2022-10-29 00:00:00";
        let newTime = new Date().getTime(); // 当前时间戳
        let time1 = new Date(time).getTime(); //有效期
        let towTime = this.$moment().add(2, "M"); //下二个月
        let oneTime = this.$moment().add(1, "W"); //下一周
        towTime = new Date(towTime).getTime();
        oneTime = new Date(oneTime).getTime();
        // console.log(towTime,newTime,'jasdjajk',effectiveTime);
        // console.log(towTime,'两个月时间');
        // console.log(oneTime,'一周时间');
        if (time1 <= towTime && time1 <= oneTime) {
          this.endtimeType = "1";
          return "red w210"; // 不足一周
        } else if (time1 <= towTime) {
          this.endtimeType = "2";
          return "yellow w210"; // 不足二个月
        } else {
          this.endtimeType = "3";
          return "";
        }
        // 2022/11/22
      };
    }
  },
  async created() {
    this.InitHospital(); //权限测试版本
    // 头像
    this.getUpdate();
    this.PopupDatalist = true; //开屏弹窗
    this.messageShow(); //判断是否要消息通知
    this.nowtime();
    this.date.userID = loginvuex.state.userID;
    this.date.guid = loginvuex.state.user;
    this.date.hid = loginvuex.state.hid;
    this.ksName = JSON.parse(localStorage.getItem("userlist")).hidName;
    this.type = this.$route.query.type || JSON.parse(localStorage.getItem("userlist")).userType; // 判断是否是考生进入
    console.log(this.type,'身份');
    // console.log(this.date);
    let res;
    try {
      res = await systemclassification.gethostorysystem(this.date);
    } catch (error) {
      // console.log(error);
      if (error.message === "Request failed with status code 401") {
        this.$message.error("账号信息超时，请重新登录");
        // 1. 清除 store 中的用户的信息
        localStorage.removeItem("userlist");
        // 2. 跳转登录页
        this.$router.push("/login");
      }
    }
    // console.log(res);
    // console.log(this.dateimg);
    //这里默认初始化一次新用户进入
    if (this.type != "ks" && this.type != 'student') {
      // 非考生登录
      if (res.data.Data.length === 0) {
        // console.log(this.dateimg);
        let resa = await systemclassification.getsystem(this.date);
        //  this.dateimg = resa.data.Data;
        this.isfirstlogin = true;
        // console.log(resa);
        this.dialogVisible = true;
      } else {
        //第二次进入系统时候的分类选择(已选择历史分类了)  并且开始处理请求题库请求了，请求一级题库列表
        this.select.softName = res.data.Data[0].softName;
        // console.log(res.data, 0); //这个地方，北研的账号有问题
        this.select.ID = res.data.Data[0].ID;
        this.date.ID = res.data.Data[0].ID;
        // console.log(this.date);
        let resr = await qusetionfcuntion.examApp(this.date);
        // 此处考生进来没数据报错，非空处理
        if (resr.data.Data.length != 0) {
          resr.data.Data[resr.data.Data.length - 1].children = resr.data.Data[
            resr.data.Data.length - 1
          ].children?.filter(items => {
            return items.children.length != 0;
          });
        }

        localStorage.setItem("testbank", JSON.stringify(resr.data.Data));
        localStorage.setItem("testbank", JSON.stringify(resr.data.Data));
      }
    }

    await this.getUserData();
    if (JSON.parse(sessionStorage.getItem("xufeiInfo"))) {
      this.endtime = JSON.parse(sessionStorage.getItem("xufeiInfo")).endtime; // 考核云到期时间
    }
    this.$bus.$on("go", content => {
      this.content = content; //这里是接收头像
    });
  }
};
</script>

<style lang="scss" scoped>
.app-header {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .headed_left {
    display: flex;
    align-items: center;
    h3 {
      margin-left: 24px;
      width: 220px;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    img {
      width: 36px;
      height: 36px;
      &:nth-child(3) {
        width: 24px;
        height: 24px;
        margin-left: 84px;
        cursor: pointer;
      }
    }
  }
  .headed_right {
    display: flex;
    align-items: center;
    //  background-color: rgb(197, 243, 243);
  }

  .content {
    box-shadow: 0px 1px 6px #d5ebff;
    border-radius: 6px;
    margin-right: 30px;
    display: flex;
    align-items: center;
    padding: 3px 16px;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
    }
    h5 {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 39px;
      color: #606666;
      margin-left: 11px;
    }
  }

  .el-dropdown-link {
    display: flex;
    align-items: center;
    min-width: 169px;
    padding: 12px;
    height: 45px;
    justify-content: center;
    box-shadow: 0px 1px 6px #d5ebff;
    opacity: 1;
    border-radius: 6px;
    h3 {
      margin-left: 14px;
      margin-right: 17px;
    }
  }
}
.el-dropdown-link2 {
  display: flex;
  align-items: center;
  padding: 12px;
  height: 45px;
  justify-content: center;
  box-shadow: 0px 1px 6px #d5ebff;
  opacity: 1;
  border-radius: 6px;
  font-size: 18px;
  h5 {
    margin-left: 14px;
    margin-right: 17px;
  }
}
.userInfo {
  width: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  border: 1px solid #000;
}
.w210 {
  width: 210px !important;
}
::v-deep .popper__arrow {
  // border: bottom color #000 !important;;
  border-bottom-color: #000 !important;
}
// ::v-deep .popper__arrow .red {
//   border-bottom-color: #ff0000 !important;
// }
// ::v-deep .popper__arrow .yellow {
//   border-bottom-color: #ffa200 !important;
// }
.dropdwon-items {
  color: #5f5f5f;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e2e2e2;
  .icon-dropOptions {
    width: 40px;
    height: 40px;
    //  background-color: #64b5ff;
    padding: 6px;
    i {
      font-size: 30px;
    }
  }
  .dropText {
    display: flex;
    flex-flow: column nowrap;
    margin-left: 10px;
    p {
      height: 20px;
      font-weight: 600;
    }
    span {
      color: #64b5ff;
      font-weight: 600;
      text-decoration: underline;
    }
    .connectPhone {
      display: inline-block;
      color: #adadad;
      width: 150px;
    }
  }
}
.dialog_view {
  .dialog-title {
    display: flex;
    // background-color: aqua;
    align-items: center;
    h4 {
      margin-left: 30px;
      width: 154px;
      height: 30px;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  ::v-deep .el-dialog__wrapper {
    background-color: rgba(0, 21, 41, 0.7);
  }
  ::v-deep .el-dialog {
    //min-width: 58%;
    min-width: 1100px;
    background: #ffffff;
    border: 1px solid #707070;
    border-radius: 20px;
  }
  .dialogclose {
    cursor: pointer;
    margin-left: 760px;
  }
  .dialog-body {
    .cardcontent {
      width: 302px;
      height: 170px;
      position: relative;
      margin-left: 60px;
      cursor: pointer;
    }
    img {
      width: 100%;
      &:nth-child(2) {
        margin-left: 12px;
      }
    }
    h3 {
      position: absolute;
      height: 48px;
      width: 164px;
      top: 40px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ffffff;
      left: 30px;
    }
    .dialog-body-first {
      display: flex;
      > :nth-child(1) {
        margin-left: 0;
      }
    }
  }
  .dialog-footer {
    background-color: blanchedalmond;
  }
}

.onlinetime {
  // background-color: red;
  font-size: 18px;
  font-family: Arial, Helvetica, sans-serif;
  margin-right: 50px;
}
.isstilltime {
  font-size: 18px;
  color: rgb(207, 51, 51);
  font-family: Arial, Helvetica, sans-serif;
  // background-color: rgba(0, 21, 41, 0.7);
  margin-right: 50px;
  animation: gelatine 1.25s infinite;
}
@keyframes gelatine {
  80% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
    text-shadow: 0 0 5px rgb(170, 84, 84);
  }
  85% {
    -webkit-transform: scale(0.9, 1.1);
    transform: scale(0.9, 1.1);
    text-shadow: 0 0 5px rgb(179, 88, 88);
  }
  90% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
    text-shadow: 0 0 5px rgb(155, 73, 73);
  }
  95% {
    -webkit-transform: scale(1.1, 0.9);
    transform: scale(1.1, 0.9);
    text-shadow: 0 0 5px rgb(151, 64, 64);
  }
}
// 弹窗样式
.deleteExit {
  ::v-deep .el-dialog {
    width: 300px;
    height: 200px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
    }
  }
  ::v-deep .el-dialog__body {
    p {
      height: 45px;
      margin-top: 20px;
      line-height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 20px !important;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    // line-height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .el-dialog__footer {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
    text-align: center;
    span > button {
      width: 60px;
      height: 32px;
      opacity: 1;
      border-radius: 4px;
      padding: 0px;
      margin-top: 38px;
      &:nth-child(2) {
        margin-left: 90px;
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.dropdown_box {
  margin-right: 30px;
  position: relative;
}
.dropdown_box_right {
  position: relative;
}
.bubbles_box {
  position: absolute;
  // position: relative;
  top: 55px;
  left: -58px;
  width: 170px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #69c6fd;
  border-radius: 4px;
  z-index: 99 !important;
  .triangle {
    position: absolute;
    top: -10px;
    left: 80px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 10px solid #69c6fd;
  }

  p {
    color: #ffffff;
    span {
      border-bottom: 1px solid #fff;
      cursor: pointer;
    }
  }
}
.backkhy {
  // background-color: aqua;
  box-shadow: 0px 1px 6px #d5ebff;
  border-radius: 6px;
  margin-right: 30px;
  display: flex;
  align-items: center;
  padding: 3px 16px;
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
  }
  h5 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 39px;
    color: #606666;
    margin-left: 11px;
  }
}
.exit_btn {
  margin-left: 14px;
}
.iframe {
  width: 500px;
  height: 800px;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.Popup_view {
  ::v-deep .el-dialog {
    width: 600px;
    height: 540px;
    background-image: url("../../../assets/dialogimg/Popup1.png");
    background-size: 100% 100%;
    border-radius: 10px;
    position: relative;
    .el-dialog__headerbtn {
      display: none;
    }
    .img_down {
      position: absolute;
      top: 7%;
      right: 5%;
      cursor: default !important;
    }
  }
}
.upDateback {
  ::v-deep .el-dialog {
    position: relative;
    background-color: #00000000;
    background-image: url("../../../../src/assets/dialogimg/upDateback.png");
    background-size: 100% 100%;
    width: 694px;
    height: 597px;
    box-shadow: none;
    .el-dialog__headerbtn {
      display: none;
    }
    .zidingyiheader {
      display: flex;
      justify-content: space-between;
      padding: 20px 0px 0px 30px;
      p {
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 44px;
        color: #ffffff;
        text-shadow: 0px 3px 2px #1a97ef;
        opacity: 1;
      }
      .closebtn {
        width: 20px;
        height: 20px;
        cursor: pointer;
        background-size: 100% 100%;
        background-image: url("../../../../src/assets/dialogimg/dialogclose.png");
      }
    }
    h2 {
      overflow: auto;
      margin-left: 20px;
      margin-top: 180px;
      font-weight: 400;
      font-size: 20px;
      color: #999999;
      opacity: 1;
      height: 150px;
    }
    .dibu {
      display: flex;
      justify-content: center;
      position: absolute;
      margin: 10px auto;
      left: 0px;
      right: 0px;
      button {
        width: 200px;
        height: 60px;
        border-radius: 100px;
        background: linear-gradient(180deg, #43ccff 100%, #1890ff 100%);
        color: white;
        font-size: 20px;
      }
    }
  }
}
.isPopup {
  ::v-deep .el-dialog__wrapper {
    justify-content: start;
  }
  ::v-deep .el-dialog {
    width: 500px !important;
    height: 540px;
    //padding: 0 !important;
    //left: 20px;
    margin-top: 120px !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }
  ::v-deep .el-dialog__header {
    display: none;
  }
  .img_down {
    position: absolute;
    top: 2% !important;
    right: 5%;
    cursor: default !important;
  }
}
.receivw {
  width: 500px;
  height: 480px;
  opacity: 0;
}
.prompt_view {
  display: flex;
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 10px;
  p {
    margin-right: 12px;
  }
  .el-button {
    width: 66px;
    height: 28px;
    line-height: 5px;
    background: #1890ff;
    color: #fff;
  }
}
.red {
  color: #ff0000 !important;
  border-color: #ff0000 !important;
  ::v-deep .popper__arrow {
    border-bottom-color: #ff0000 !important;
  }
}
.yellow {
  color: #ffa200 !important;
  border-color: #ffa200 !important;
  ::v-deep .popper__arrow {
    border-bottom-color: #ffa200 !important;
  }
}
.red_span {
  color: #ff0000;
  flex-wrap: wrap;
  font-size: 12px;
  position: absolute;
  top: 0;
  right: 6%;
}
.mr12 {
  margin-left: 32px;
}
</style>
